import {defaultStockData, StockDto} from "src/dtos/stock/stockDto";

// 소계 관련 상수 정의
export const WMS2011_R01_SUBTOTAL_TYPES = {
    ITEM: 'item',
    WAREHOUSE: 'warehouse',
    LOGICCENTER: 'logiccenter',
} as const;

export const WMS2011_R01_SUBTOTAL_LEVELS = {
    ITEM: 1,
    WAREHOUSE: 2,
    LOGICCENTER: 3,
    DETAIL: 4,
} as const;


// ===============================
// 소계 관련 인터페이스들
// ===============================

// 품목별 소계 데이터 인터페이스
export interface WMS2011_R01ItemSubtotalData extends StockDto {
    brandCd: string;
    brandNm: string;
    itemGroup: string;
    count: number;
}

// 창고별 소계 데이터 인터페이스
export interface WMS2011_R01WarehouseSubtotalData extends WMS2011_R01ItemSubtotalData {
    groupKey?: string;
}

// 물류센터별 소계 데이터 인터페이스
export interface WMS2011_R01LogicCenterSubtotalData extends WMS2011_R01ItemSubtotalData {
    groupKey?: string;
}



// 소계 행 인터페이스들
export interface WMS2011_R01ItemSubtotalRow extends StockDto {
    isSubtotal: true;
    subtotalType: typeof WMS2011_R01_SUBTOTAL_TYPES.ITEM;
    level: typeof WMS2011_R01_SUBTOTAL_LEVELS.ITEM;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    brandCd: string;
    brandNm: string;
    itemGroup: string;
    itemStatus: string;
}

export interface WMS2011_R01WarehouseSubtotalRow extends StockDto {
    isSubtotal: true;
    subtotalType: typeof WMS2011_R01_SUBTOTAL_TYPES.WAREHOUSE;
    level: typeof WMS2011_R01_SUBTOTAL_LEVELS.WAREHOUSE;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    itemGroup: string;
    itemStatus: string;
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
}

export interface WMS2011_R01LogicCenterSubtotalRow extends StockDto {
    isSubtotal: true;
    subtotalType: typeof WMS2011_R01_SUBTOTAL_TYPES.LOGICCENTER;
    level: typeof WMS2011_R01_SUBTOTAL_LEVELS.LOGICCENTER;
    groupKey: string;
    groupLabel: string;
    count: number;
    itemCd: string;
    itemNm: string;
    itemSpec: string;
    itemUnit: string;
    itemGroup: string;
    itemStatus: string;
    logicCenter: string;
    logicCenterNm: string;
    warehouseCd: string;
    warehouseNm: string;
}

export type WMS2011_R01Dto =
    | WMS2011_R01ItemSubtotalRow
    | WMS2011_R01WarehouseSubtotalRow
    | WMS2011_R01LogicCenterSubtotalRow
    | WMS2011_R01StockDto;

// 백엔드 응답(StockDto 기반) + 그리드 상세행 공통 타입
export interface WMS2011_R01StockDto extends StockDto {
    brandCd?: string;
    brandNm?: string;
    itemGroup?: string;
    locationCd?: string;
    locationNm?: string;
    isSubtotal?: false;
    level?: typeof WMS2011_R01_SUBTOTAL_LEVELS.DETAIL;
}

export const defaultWMS2011_R01Dto: WMS2011_R01Dto = {
    ...defaultStockData,
    brandCd: '',
    brandNm: '',
    itemGroup: '',
    locationCd: '',
    locationNm: '',
};


